export const COMPANY_TYPES = [
    { value: 'KNN', label: 'KNN' },
    { value: 'GAMEUP', label: 'GameUp' },
];
